import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'allowances/'

const initialState = {
    allowances: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getAllowances = createAsyncThunk('allwnc/ga', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleAllowances = createAsyncThunk('allwnc/gsa', async (id, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}/${id}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addAllowance = createAsyncThunk('allwnc/aa', async (allowancesData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, allowancesData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const editAllowance = createAsyncThunk('allwnc/ea', async (id, thunkAPI) => {
    try {
        const result = await axios.put(`${API_URL}/${id.id}`, id)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteAllowance = createAsyncThunk('allwnc/da', async (id, thunkAPI) => {
    try {
        const result = await axios.delete(`${API_URL}/${id}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const departmentSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.allowances = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllowances.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllowances.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.allowances = action.payload
            })
            .addCase(getAllowances.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.allowances = []
            })
    }
})

export const { reset } = departmentSlice.actions

export default departmentSlice.reducer